import { Sparkles, Gem, ArrowRight } from "lucide-react";
import {
  COLOR_CHARCOAL,
  COLOR_MUTED,
} from "../constants/upsellPage.constants";
import AmbientGradient from "./primitives/AmbientGradient";
import Pill from "./primitives/Pill";
import type { HeroSectionProps } from "../types/upsellPage.types";

const HeroSection = ({
  planName,
  title,
  description,
  ctaLabel,
  targetTier = "standard",
}: HeroSectionProps) => {
  const isPremium = targetTier === "premium";
  const PlanIcon = isPremium ? Gem : Sparkles;

  return (
    <section className="relative isolate px-4 pt-24 pb-20 sm:pt-32 sm:pb-28">
      <AmbientGradient position="hero" />

      <div className="relative z-10 mx-auto flex max-w-4xl flex-col items-center text-center">
        <Pill
          variant="tinted-purple"
          size="sm"
          icon={<PlanIcon size={14} strokeWidth={2} />}
          className="animate-upsell-fade-in mb-7"
        >
          {planName}
        </Pill>

        <h1
          className="animate-upsell-fade-in-up mb-6 pb-1 font-light tracking-tight text-balance"
          style={{
            color: COLOR_CHARCOAL,
            fontSize: "clamp(1.875rem, 3.6vw, 3.25rem)",
            lineHeight: 1.15,
            letterSpacing: "-0.02em",
            animationDelay: "0.05s",
          }}
        >
          {title}
        </h1>

        <p
          className="animate-upsell-fade-in-up mb-10 max-w-xl text-base sm:text-lg"
          style={{
            color: COLOR_MUTED,
            lineHeight: 1.55,
            fontWeight: 400,
            animationDelay: "0.15s",
          }}
        >
          {description}
        </p>

        <div
          className="animate-upsell-fade-in-up"
          style={{ animationDelay: "0.25s" }}
        >
          <Pill
            as="button"
            variant="purple"
            size="lg"
            type="button"
            onClick={() => document.getElementById("upgrade-section")?.scrollIntoView({ behavior: "smooth" })}
            icon={null}
          >
            {ctaLabel}
            <ArrowRight size={16} strokeWidth={2} />
          </Pill>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
